// src/App.jsx
import React, { useState, useEffect } from 'react';
import './index.css';
import Navbar from './Components/Navbar/Navbar';
import Hi from './Pages/Hi/Hi';
import PIV from './Pages/PIV/PIV';
import Past from './Pages/Past/Past';
import Present from './Pages/Present/Present';
import Showcase from './Pages/Showcase/Showcase';
import Future from './Pages/Future/Future';
import Bottom from './Pages/Bottom/Bottom';
import ProjectDetail from './Pages/ProjectDetail/ProjectDetail'; 

import { PreviewProvider } from './context/PreviewContext';

export default function App() {
  const [activeProjectId, setActiveProjectId] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [forcedProgress, setForcedProgress] = useState(undefined);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        setActiveProjectId(hash.replace('#', ''));
        if (window.history.state && window.history.state.scrollPos) {
          setScrollPosition(window.history.state.scrollPos);
          setForcedProgress(window.history.state.progress);
        } else {
          // Fallback bij directe refresh op projectpagina: zet voortgang rond de showcase (~75%)
          setForcedProgress(0.75);
        }
      } else {
        setActiveProjectId(null);
        setForcedProgress(undefined);
      }
    };

    handleHashChange();
    window.addEventListener('popstate', handleHashChange);
    return () => window.removeEventListener('popstate', handleHashChange);
  }, []);

  const handleProjectSelect = (id) => {
    const currentScroll = window.scrollY;
    const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
    const currentProgress = totalHeight > 0 ? currentScroll / totalHeight : 0;

    setScrollPosition(currentScroll);
    setForcedProgress(currentProgress);
    setActiveProjectId(id);
    
    window.history.pushState({ projectId: id, scrollPos: currentScroll, progress: currentProgress }, '', `#${id}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

 const handleBackToHome = () => {
  setActiveProjectId(null);
  setForcedProgress(undefined);
  window.history.pushState(null, '', window.location.pathname);
  
  // VERANDERD: We verhogen de timer van 10ms naar 100ms. 
  // Dit is onzichtbaar voor het oog, maar geeft de afbeeldingen de tijd om hun ruimte in te nemen!
  setTimeout(() => {
    window.scrollTo({ top: scrollPosition, behavior: 'instant' });
  }, 50); 
};

  return (
    <PreviewProvider onProjectClick={handleProjectSelect}>
    <div className="canvas-wrapper">
      <Navbar 
        onLogoClick={handleBackToHome} 
        activeSectionProp={activeProjectId ? 'showcase' : undefined} 
        forcedScrollProgress={forcedProgress}
      />

      {activeProjectId ? (
        <ProjectDetail projectId={activeProjectId} />
      ) : (
        <>
<Hi onProjectClick={handleProjectSelect} />
          <PIV />
          <Past />
          <Present />
          <Future />
          <Showcase onProjectClick={handleProjectSelect} />
          
          <Bottom />
        </>
      )}
    </div>
    </PreviewProvider>
  );
}